

























































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { TbShopAccount,TbShop } from '@/http';
import { Toast,Dialog } from 'vant';
import { padHeadPanel4,selectAddressPanel } from "@/components"
import {State,Getter,Action,Mutation,namespace} from 'vuex-class'
var md5 = require("js-md5");
@Component({
    components: {padHeadPanel4,selectAddressPanel},
})
export default class shopUpdate extends Vue {
   
    userInfo:any={};
    shopInfo:any={};
    form:any={
        shopNo:"",
        contactName:"",
        phone:"",
        province:"",
        city:"",
        area:"",
        address:"",
        shopName:"",
        businessCategoryName:"",
        businessCategoryCode:"",
    };
    addressName="";
    list=[];
    isloading = false;

    //新增功能
    showjylm = false;

    moveHandle() {}
    async mounted() {
        this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
        this.shopInfo = JSON.parse(localStorage.getItem("padShopInfo"));
        this.form.shopNo = this.shopInfo.shopNo;
        this.form.contactName = this.userInfo.contactName;
        this.form.phone = this.userInfo.phone;
        this.addressName = this.shopInfo.province+this.shopInfo.city+this.shopInfo.area;
        this.form.province = this.shopInfo.province;
        this.form.city = this.shopInfo.city;
        this.form.area = this.shopInfo.area;
        this.form.address = this.shopInfo.address;
        if(!this.userInfo.isPrimary){
            this.form.shopName = this.shopInfo.shopName;
            this.form.businessCategoryName = this.shopInfo.businessCategoryName;
            this.form.businessCategoryCode = this.shopInfo.businessCategoryCode;
        }
        this.getLmList();
    }
    async created() {
    
    }

    async getLmList(){
        let res = await TbShop.GetBusinessCategorys();
        this.list = res.data[0].items;
        
    }

    chooseLm(item){
        if(!this.userInfo.isPrimary) return;
        this.form.businessCategoryName = item.name;
        this.form.businessCategoryCode = item.id;
        
    }
  

    logoutFun(){
        this.$router.push("/pad/padLogin2");
    }
    onConfirmAddress(value){
        let arr= JSON.parse(value);
        this.form.province = arr[0];
        this.form.city = arr[1];
        this.form.area = arr[2];
        this.addressName = this.form.province+this.form.city+this.form.area;
    }

    showAddress(){
        this.$refs['selectAddressPanel'].showFun();
    }
    showJylm(){
        if(!this.userInfo.isPrimary) return;
        this.showjylm = true;
    }
    onClose(){
        this.showjylm = false;
    }
    Confirm(value){
        // this.$emit("supplierConfirm",value);
        console.log('vaule',value);
        this.form.businessCategoryName = value.name;
        this.form.businessCategoryCode = value.id;
        this.showjylm = false;
    }

    async confirmFun(){
        if(this.isloading) return;
        if(!this.form.shopName){
            Toast("请输入店铺名称");
            return;
        }
        if(!this.form.businessCategoryCode){
            Toast("请选择经营类目");
            return;
        }
        this.isloading = true;
        try {
            await TbShop.PutUpdateTbShop({
               id:this.shopInfo.id, 
               shopName:this.form.shopName, 
               name:this.form.contactName, 
               businessCategoryCode:this.form.businessCategoryCode, 
               businessCategoryName:this.form.businessCategoryName, 
               province:this.form.province, 
               city:this.form.city, 
               area:this.form.area, 
               address:this.form.address, 
            })
            Toast("店铺激活成功");
            this.isloading = false;
            let resShop = await TbShop.GetTbShopById({id:this.shopInfo.id})
            localStorage.setItem("padShopInfo",JSON.stringify(resShop))

            let userInfo:any = JSON.parse(localStorage.getItem('padUserinfo'));
            userInfo.shopName = this.form.shopName;
            if(this.form.businessCategoryName=='珠宝首饰'||this.form.businessCategoryName=='内衣家居'||this.form.businessCategoryName=='文创'||this.form.businessCategoryName=='谷子'||this.form.businessCategoryName=='手作'||this.form.businessCategoryName=='杂货'){
                userInfo.isJewelry = true;
                if(window.webkit){
                    window.webkit.messageHandlers.setPageSize.postMessage(3);
                }
            }else{
                if(window.webkit){
                    window.webkit.messageHandlers.setPageSize.postMessage(1);
                }

            }
            localStorage.setItem('padUserinfo',JSON.stringify(userInfo));
            let loginInfo:any = JSON.parse(localStorage.getItem('loginInfo'));
            loginInfo.shopName = this.form.shopName;
            localStorage.setItem('loginInfo',JSON.stringify(loginInfo));
            this.$router.push("/pad/mainPage/index");
            if(window.webkit){
                window.webkit.messageHandlers.searchForBluetooth.postMessage('searchForBluetooth');
                window.webkit.messageHandlers.getVersion.postMessage('getVersion');
            }
        } catch (error) {
            this.isloading = false;
        }
    }
   

}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/shopUpdate.vue